import { render, staticRenderFns } from "./openIdPage.vue?vue&type=template&id=4f357705&scoped=true&"
import script from "./openIdPage.vue?vue&type=script&lang=js&"
export * from "./openIdPage.vue?vue&type=script&lang=js&"
import style0 from "./openIdPage.vue?vue&type=style&index=0&id=4f357705&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f357705",
  null
  
)

export default component.exports